
import MusicSquareRemove from "../../../assets/duotone/MusicSquareRemove.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function MusicSquareRemoveIcon({ className, dataTestid = "MusicSquareRemoveIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <MusicSquareRemove data-testid={dataTestid} className={classes} {...rest} />
  );
}
